import { createContext, useContext } from 'react';

const PdfContext = createContext<{ isPdfAllowed: boolean }>({
  isPdfAllowed: false,
});

export const PdfProvider: React.FC<{
  isPdfAllowed: boolean;
  children: React.ReactNode;
}> = ({ isPdfAllowed, children }) => (
  <PdfContext.Provider value={{ isPdfAllowed }}>{children}</PdfContext.Provider>
);

export const usePdfConfig = () => {
  return useContext(PdfContext);
};
